import CustomWarningAlert from './CustomWarningAlert'

export default CustomWarningAlert
